import Service from "../../../../utils/api/service";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _debounce from "lodash.debounce";
export default {
  name: "CreateProductDiscount",
  data() {
    return {
      isUpdating: false,
      isCreating: false,
      freeShipping: true,
      loading: {
        isProductSearching: false,
        customerLoading: false,
        customerGroupLoading: false,
        isVariantSearching: false,
        categoryLoading: false,
      },
      body: {
        name: "",
        discountType: "percentage",
        discountValue: 0,
        freeShipping: true,
        categoryIds: [],
        productIds: [],
        customerGroupIds: [],
        customerIds: [],
        startDate: this.$moment().startOf("day").toDate(),
        endDate: this.$moment().endOf("day").toDate(),
        status: "active",
        customerGroupAction: "include",
        customerAction: "include",
        isCombineBP: false, // true | false
        variantIds: [],
        description: "",
      },
      data: {
        productList: [],
        variants: [],
        categories: [],
        customers: [],
        customerGroups: [],
      },
      display: {
        category: false,
      },
      model: {
        products: [],
        variants: [],
        categories: [],
        customers: [],
        customerGroups: [],
      },
      showTimePanel: false,
      showTimeRangePanel: false,
      actions: [
        { id: "include", name: "Include" },
        { id: "exclude", name: "Exclude" },
      ],
      discountTypes: [
        { id: "fix_amount", name: "Fixed Amount" },
        { id: "percentage", name: "Percentage" },
      ],
    };
  },
  components: { Multiselect, DatePicker },
  computed: {
    debouncedOnSearchProducts() {
      return _debounce(this.searchProducts, 500);
    },
    debouncedOnSearchVariants() {
      return _debounce(this.searchVariants, 500);
    },
    debouncedOnGetCustomers() {
      return _debounce(this.getCustomers, 500);
    },
  },
  created() {
    this.getCategory();
    // this.searchProducts();
    // this.getCustomers();
    this.getCustomerGroups();
  },
  methods: {
    /***
     * @apply to check auto remove
     * - product by category id
     * - variant by product id
     * - customer by customer group id
     */
    onInputUpdateCategoryId() {
      const categoryIds = this.model.categories.map((cat) => cat?.id);

      // Keep only products that belong to valid categories
      this.model.products = this.model.products.filter((product) => {
        const categoryId = product?.category?.id; // match product's category.id
        return categoryIds.includes(categoryId);
      });

      this.onInputUpdateProductId();
    },

    onInputUpdateProductId() {
      const productIds = this.model.products.map((prod) => prod.id);

      // Keep only variants that belong to valid products
      this.model.variants = this.model.variants.filter((variant) => {
        return productIds.includes(variant?.productId);
      });
    },

    onInputUpdateCustomerGroupId() {
      const groupIds = this.model.customerGroups.map((group) => group.id);

      // Keep only customers that belong to valid customer groups
      this.model.customers = this.model.customers.filter((customer) => {
        return groupIds.includes(customer?.customerGroupId);
      });
    },

    reNewTimestamp: function (timestamp) {
      const iso = new Date(timestamp).toISOString();
      const date = new Date(iso);
      date.setUTCHours(date.getUTCHours() - 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    goBack() {
      this.$router.push({
        name: "ListProductDiscount",
        query: {
          page: 1,
          limit: 10,
        },
      });
    },

    getCategory() {
      Service.getAllCategories("").then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCategory();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.categories = response.data;
        }
      });
    },

    getCustomers(query) {
      let param =
        typeof query === "string" && query
          ? "?status=active&search=" + query
          : "?status=active";
      if (this.model.customerGroups && this.model.customerGroups.length) {
        param += this.model.customerGroups
          .map((item) => `&customerGroupIds=${item.id}`)
          .join("&");
      }
      this.loading.customerLoading = true;

      Service.getCustomers(param).then((response) => {
        this.loading.customerLoading = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomers();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let customers = response.data;
          let newList = [
            {
              name: "Select All",
              list: customers.map((item) => {
                return {
                  ...item,
                  fullName:
                    (item?.bpName
                      ? item?.bpName
                      : item?.firstName + " " + item?.lastName) +
                    " " +
                    "(" +
                    item?.code +
                    ")",
                };
              }),
            },
          ];

          this.data.customers = newList;
        }
      });
    },

    getCustomerGroups() {
      let params = "?limit=150&offset=0";

      Service.getCustomerGroups(params).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomerGroups();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.customerGroups = response.data;
        }
      });
    },

    showCheckboxes() {
      if (this.display.category) {
        this.display.category = false;
      } else {
        this.display.category = true;
      }
    },

    searchProducts(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";

      if (this.model.categories && this.model.categories.length) {
        param += this.model.categories
          .map((item) => `&categoryIds=${item.id}`)
          .join("&");
      }
      this.loading.isProductSearching = true;

      Service.getAllProducts(param).then((response) => {
        this.loading.isProductSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchProducts();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let productList = response.data;
          let newList = [
            {
              name: "Select All",
              list: productList,
            },
          ];

          this.data.productList = newList;
        }
      });
    },

    searchVariants(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";

      if (this.model.products && this.model.products.length) {
        param += this.model.products
          .map((item) => `&productIds=${item.id}`)
          .join("&");
      }
      this.loading.isVariantSearching = true;

      Service.getAllProductVariants(param).then((response) => {
        this.loading.isVariantSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchVariants();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let variants = response.data;
          let newList = [
            {
              name: "Select All",
              list: variants,
            },
          ];

          this.data.variants = newList;
        }
      });
    },

    submitCreate() {
      let validatedMessage = this.validateBody(this.body);
      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.onCreate();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(body) {
      if (!body.name) {
        return "Discount Name cannot be empty!";
      } else if (!body.discountType) {
        return "Type group cannot be empty!";
      } else if (
        typeof body.discountValue === "string" ||
        body.discountValue <= 0
      ) {
        return "Discount Value cannot be empty, it must be bigger than zero!";
      } else if (!this.model.categories.length) {
        return "Product Category cannot be empty!";
      } else if (!this.model.customerGroups.length) {
        return "Customer Group cannot be empty!";
      } else if (!body.startDate) {
        return "Start date/time cannot be empty!";
      } else if (!body.endDate) {
        return "End date/time cannot be empty!";
      } else if (!body.status) {
        return "Status order cannot be empty!";
      } else {
        return "ok";
      }
    },

    updateTimestamp: function (timestamp) {
      const iso = timestamp.toISOString();
      const date = new Date(iso);
      date.setUTCHours(date.getUTCHours() + 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    onCreate() {
      this.body.productIds = [];
      if (this.model.products) {
        for (let index = 0; index < this.model.products.length; index++) {
          const product = this.model.products[index];
          this.body.productIds.push(product.id);
        }
      }

      this.body.customerGroupIds = [];
      if (this.model.customerGroups) {
        for (let index = 0; index < this.model.customerGroups.length; index++) {
          const customerGroup = this.model.customerGroups[index];
          this.body.customerGroupIds.push(customerGroup.id);
        }
      }

      this.body.customerIds = [];
      if (this.model.customers) {
        for (let index = 0; index < this.model.customers.length; index++) {
          const customer = this.model.customers[index];
          this.body.customerIds.push(customer.id);
        }
      }

      this.body.categoryIds = [];
      if (this.model.categories) {
        for (let index = 0; index < this.model.categories.length; index++) {
          const category = this.model.categories[index];
          this.body.categoryIds.push(category.id);
        }
      }

      this.body.variantIds = [];
      if (this.model.variants) {
        for (let index = 0; index < this.model.variants.length; index++) {
          const variant = this.model.variants[index];
          this.body.variantIds.push(variant.id);
        }
      }

      let body = {
        name: this.body.name,
        discountType: this.body.discountType,
        discountValue: this.body.discountValue,
        categoryIds: this.body.categoryIds,
        productIds: this.body.productIds,
        variantIds: this.body.variantIds,
        customerIds: this.body.customerIds,
        customerGroupIds: this.body.customerGroupIds,
        startDate: this.updateTimestamp(this.body.startDate),
        endDate: this.updateTimestamp(this.body.endDate),
        status: this.body.status,
        isCombineBP: this.body.isCombineBP,
        description: this.body.description,
      };

      Service.createProductDiscount(body).then((response) => {
        this.isCreating = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.onCreate();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.resetBody();
          this.$toasted.show("Product discount has been created.");
          this.goBack();
        }
      });
    },

    resetBody() {
      this.body = {
        name: "",
        discountType: "percentage",
        discountValue: 0,
        categoryIds: [],
        productIds: [],
        customerGroupIds: [],
        customerIds: [],
        startDate: this.$moment().startOf("day").toDate(),
        endDate: this.$moment().endOf("day").toDate(),
        status: "active",
        isCombineBP: false,
        description: "",
      };
      this.model.products = [];
      this.model.categories = [];
      this.model.customers = [];
      this.model.customerGroups = [];
    },

    toUpperCase(string) {
      return string.toUpperCase();
    },

    toCapitalLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
  },
};
